import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import RowAvatar from './RowAvatar';
import {
  ListRow, RowMain, RowName, RowSide, StatusChip, LinkButton,
} from '../styles';
import { CARD_IDS } from '../constants';
import { formatDuration, formatNumber } from '../format';
import { buildDrillLink } from '../../../utils/attendanceFilterQuery';

const CONFIG = {
  late: {
    cardKey: 'en-cok-gec-kalanlar', title: 'attendanceDashboard.topLate.title', empty: 'attendanceDashboard.topLate.empty', domId: CARD_IDS.topLate,
  },
  undertime: {
    cardKey: 'en-cok-eksik-calisanlar', title: 'attendanceDashboard.topUndertime.title', empty: 'attendanceDashboard.topUndertime.empty', domId: CARD_IDS.topUndertime,
  },
};

// İlk 5 (En Çok Geç Kalanlar / En Çok Eksik Çalışanlar); "Tümü →" listeyi panelin süzgeçleri ve bugüne kadar olan
// aralıkla açar. Ad/fotoğraf/statü Employee'den (backend).
export default function TopPeopleCard({
  kind, slice, query, effectiveTo, closedTo, drillable = true,
}) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const lang = i18n.language;
  const cfg = CONFIG[kind];
  const items = slice.data?.items || [];

  // Eksik çalışma dünde biter (bugün henüz bitmedi); geç kalma bugüne kadar.
  const to = kind === 'undertime' ? (closedTo || query?.to) : (effectiveTo || query?.to);
  const openAll = query && drillable ? (
    <span data-export-exclude>
      <LinkButton
        type="button"
        data-action="all"
        onClick={() => history.push(buildDrillLink(kind, query, { to }))}
      >
        {t('attendanceDashboard.all')}
      </LinkButton>
    </span>
  ) : null;

  return (
    <DashboardCard
      cardKey={cfg.cardKey}
      title={t(cfg.title)}
      span={4}
      spanMd={3}
      slice={slice}
      empty={items.length === 0}
      emptyText={t(cfg.empty)}
      domId={cfg.domId}
      headerExtra={openAll}
    >
      <div>
        {items.map((item) => (
          <ListRow key={item.userId} data-person={item.userId}>
            <RowAvatar src={item.profilePicture} name={item.fullName || t('attendanceDashboard.unknownPerson')} size={28} />
            <RowMain>
              <RowName>
                {item.fullName || t('attendanceDashboard.unknownPerson')}
                {item.employeeStatusName ? <StatusChip>{item.employeeStatusName}</StatusChip> : null}
              </RowName>
            </RowMain>
            <RowSide style={{ fontSize: 12, fontVariantNumeric: 'tabular-nums' }}>
              {kind === 'late'
                ? t('attendanceDashboard.topLate.value', {
                  times: formatNumber(item.occurrences, lang), minutes: formatNumber(item.minutes, lang),
                })
                : formatDuration(item.minutes, t)}
            </RowSide>
          </ListRow>
        ))}
      </div>
    </DashboardCard>
  );
}
